import { useTranslation } from "react-i18next";
import MarketingShell, { LegalSection } from "@/components/MarketingShell";

export default function Terms() {
  const { t } = useTranslation();
  return (
    <MarketingShell
      eyebrow={t("legal.terms.eyebrow")}
      title={t("legal.terms.title")}
      updated={t("legal.terms.updated")}
    >
      <p className="text-lg text-foreground">{t("legal.terms.intro")}</p>

      <LegalSection heading={t("legal.terms.s1h")}><p>{t("legal.terms.s1b")}</p></LegalSection>
      <LegalSection heading={t("legal.terms.s2h")}><p>{t("legal.terms.s2b")}</p></LegalSection>
      <LegalSection heading={t("legal.terms.s3h")}><p>{t("legal.terms.s3b")}</p></LegalSection>
      <LegalSection heading={t("legal.terms.s4h")}><p>{t("legal.terms.s4b")}</p></LegalSection>
      <LegalSection heading={t("legal.terms.s5h")}><p>{t("legal.terms.s5b")}</p></LegalSection>
      <LegalSection heading={t("legal.terms.s6h")}><p>{t("legal.terms.s6b")}</p></LegalSection>
      <LegalSection heading={t("legal.terms.s7h")}><p>{t("legal.terms.s7b")}</p></LegalSection>
      <LegalSection heading={t("legal.terms.s8h")}>
        <p>
          {t("legal.terms.s8b")}{" "}
          <a href="mailto:info@aiboosters.net" className="text-intl underline underline-offset-4">info@aiboosters.net</a>.
        </p>
        <p className="font-mono text-xs text-muted-foreground mt-2">{t("legal.terms.company")}</p>
      </LegalSection>
    </MarketingShell>
  );
}
